/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useRef, useState, useCallback, useEffect } from 'react'
import { createUseStyles } from 'react-jss'
import classNames from 'classnames'
import Slider from 'react-slick'
import gsap from 'gsap'
// import useMouse from '@/hooks/useMouse'
import style from './style'

const useStyles = createUseStyles(style)

const ModalGallery = ({
  gallery,
  initialSlide,
}) => {
  const classes = useStyles(style)
  const $root = useRef()
  const $carousel = useRef()
  const $gallery = useRef()
  const $carouselWrap = useRef()
  const $currentSlide = useRef()
  const $cursor = useRef()
  const [currentSlide, setCurrentSlide] = useState(parseInt(initialSlide, 10))
  const [ready, setReady] = useState(false)

  /*------------------------------
  Pagination
  ------------------------------*/
  const renderPagination = useCallback(() => {
    return (
      <div className={classes.pagination}>
        <span className={classes.currentSlide} ref={$currentSlide}>{currentSlide + 1 < 10 ? `0${currentSlide + 1}` : (currentSlide + 1)}</span>
        {' / '}
        {gallery.length - 1 < 10 ? `0${gallery.length}` : gallery.length}
      </div>
    )
  }, [currentSlide])

  /*------------------------------
  Cursor
  ------------------------------*/
  // useMouse(({ easeX, easeY }) => {
  //   Object.assign($cursor.current.style, {
  //     top: `${easeY}px`,
  //     left: `${easeX}px`,
  //   })
  // })

  /*------------------------------
  Rotate Cursor
  ------------------------------*/
  const rotateCursor = (bool) => {
    const classToggle = bool ? 'add' : 'remove'
    $cursor.current.classList[classToggle]('prev')
  }

  /*------------------------------
  Render Gallery
  ------------------------------*/
  const renderGallery = () => {
    const gallerySlides = gallery.map((i, ind) => {
      const caption = i.caption !== '' ? (<div className={classes.galleryCaption}>{i.caption}</div>) : ''
      return (
        <div
          className={classNames({
            [classes.galleryItem]: true,
          })}
          data-image={ind}
          key={ind.toString()}
        >
          <div className={classes.galleryImg} style={{ backgroundImage: `url(${i.src})` }} />
          {caption}
        </div>
      )
    })

    if (gallerySlides) {
      const prevArrow = (<div className="slick-arrow slick-prev" onMouseEnter={() => rotateCursor(true)} />)
      const nextArrow = (<div className="slick-arrow slick-next" onMouseEnter={() => rotateCursor(false)} />)
      const slickSettings = {
        dots: false,
        arrows: false,
        prevArrow,
        nextArrow,
        speed: 150,
        touchThreshold: 20,
        fade: true,
        infinite: true,
        slidesToShow: 1,
        onInit: () => {
          setReady(true)
        },
        afterChange: (nextIndex) => {
          setCurrentSlide(nextIndex)
        },
      }

      const carousel = (
        <div className={classes.gallery} ref={$gallery}>
          <div className={classes.carouselWrap} ref={$carouselWrap}>
            <Slider
              ref={$carousel}
              {...slickSettings}
              className={classes.slick}
            >
              {gallerySlides}
            </Slider>
          </div>
          {renderPagination()}
          <div className={classes.cursor} ref={$cursor}>
            <svg>
              <use xlinkHref="#ico-arrow-right" />
            </svg>
          </div>
        </div>
      )
      return carousel
    }

    return null
  }

  /*------------------------------
  View Cursor
  ------------------------------*/
  const viewCursor = (e) => {
    if (e.type === 'mouseenter') {
      $cursor.current.classList.add('visible')
    } else {
      $cursor.current.classList.remove('visible')
    }
  }

  /*------------------------------
  Handle Keyboard
  ------------------------------*/
  const handleKeyboard = (e) => {
    // Right Arrow = 39
    // Top Arrow = 38
    // Left Arrow = 37
    // Down Arrow = 40

    if ($carousel.current) {
      if (e.which === 39 || e.which === 38) {
        $carousel.current.slickNext()
      }
      if (e.which === 37 || e.which === 40) {
        $carousel.current.slickNext()
      }
    }
  }

  /*------------------------------
  Events
  ------------------------------*/
  const events = () => {
    if ($carouselWrap.current) {
      $carouselWrap.current.addEventListener('mouseenter', viewCursor)
      $carouselWrap.current.addEventListener('mouseleave', viewCursor)
    }
    window.addEventListener('keydown', handleKeyboard)
  }

  /*------------------------------
  Destroy
  ------------------------------*/
  const destroyEvents = () => {
    if ($carouselWrap.current) {
      $carouselWrap.current.removeEventListener('mouseenter', viewCursor)
      $carouselWrap.current.removeEventListener('mouseleave', viewCursor)
    }

    if ($carousel.current) {
      window.removeEventListener('keydown', handleKeyboard)
    }
  }

  /*------------------------------
  Carousel Ready
  ------------------------------*/
  useEffect(() => {
    if (ready) {
      $carousel.current.slickGoTo(initialSlide)
      gsap.to($root.current, {
        duration: 0.5,
        opacity: 1,
        delay: 0.5,
      })

      // Events
      events()
    }

    return () => {
      destroyEvents()
    }
  }, [ready, initialSlide])

  /*------------------------------
  Render
  ------------------------------*/
  return (
    <div className={classes.root} ref={$root}>
      <div className={classes.gallery} ref={$gallery}>
        {renderGallery()}
      </div>
    </div>
  )
}

export default ModalGallery
